import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { DurationInputControlComponent } from "./duration-input-control.component";
import { DurationInputControlDirective } from "./duration-input-control.directive";

@NgModule({
	declarations: [DurationInputControlComponent, DurationInputControlDirective],
	imports: [CommonModule, FormsModule, TranslateModule, ReactiveFormsModule],
	exports: [DurationInputControlComponent, DurationInputControlDirective],
})
export class DurationInputControlModule {}
